function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "eye"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.8662109 11.5009766c-.1757812-.3061524-4.3798828-7.5009766-9.8662109-7.5009766s-9.6904297 7.1948242-9.8662109 7.5009766c-.1787109.309082-.1787109.6889648 0 .9980469.1757812.3061523 4.3798828 7.5009765 9.8662109 7.5009765s9.6904297-7.1948242 9.8662109-7.5009766c.178711-.309082.178711-.6889648 0-.9980468zm-9.8662109 6.4990234c-3.6162109 0-6.8398438-4.4882813-7.8251953-6.0058594 1.3115234-2.0483398 4.5205078-5.9941406 7.8251953-5.9941406 3.6162109 0 6.8398438 4.4882813 7.8251953 6.0058594-1.3115234 2.0483398-4.5205078 5.9941406-7.8251953 5.9941406zm0-10c-2.2060547 0-4 1.7944336-4 4s1.7939453 4 4 4 4-1.7944336 4-4-1.7939453-4-4-4zm0 6c-1.1025391 0-2-.8969727-2-2s.8974609-2 2-2 2 .8969727 2 2-.8974609 2-2 2z"
}));

var Svg136Eye = function Svg136Eye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg136Eye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/136-eye.036b4306.svg";
export { ForwardRef as ReactComponent };